'use strict';

document.addEventListener('DOMContentLoaded', () => {



  /* ---------- HEADER STICKY + SMOOTH SCROLL ---------- */
  {
    const header = document.querySelector('header.header');
    if (header) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 0) header.classList.add('fixed');
        else header.classList.remove('fixed');
      }, { passive: true });
    }

    document.querySelectorAll('.nav-link, .anchor').forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        e.preventDefault();
        const target = document.getElementById(href.slice(1));
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  new Swiper('.cards-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    autoHeight: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        //spaceBetween: 48,
        allowTouchMove: false
      }
    }
  });


  new Swiper('.slider-swiper', {
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });


  /* ---------- COIN SELECT ---------- */
  {
    const select = document.getElementById('langSelect');
    const current = select.querySelector('.current-lang');
    const list = select.querySelector('.lang-list');

    if (select && current && list) {
      select.addEventListener('click', (e) => {
        select.classList.toggle('is-open');

        const item = e.target.closest('.lang-item');
        if (!item) return;

        current.textContent = item.dataset.lang;

        select.classList.remove('is-open');
      });

      document.addEventListener('click', (e) => {
        if (!select.contains(e.target)) select.classList.remove('is-open');
      });
    }
  }

  {
    const header = document.querySelector('.header');
    const nav = header && header.querySelector('.nav');
    const navBar = header && header.querySelector('.nav-bar');
    const panelMob = header && header.querySelector('.panel-mob');
    const navBarInner = header && header.querySelector('.nav-bar-inner');

    if (nav && navBar && panelMob) {

      const navOriginalPosition = document.createComment('nav-original-position');
      nav.parentNode.insertBefore(navOriginalPosition, nav);

      const mq = window.matchMedia('(min-width: 768px)');

      const moveNavToPanel = () => {
        if (panelMob && nav.parentNode !== panelMob) {
          panelMob.insertBefore(nav, panelMob.firstChild);
        }
      };

      const moveNavBack = () => {
        if (navOriginalPosition.parentNode && nav.parentNode !== navOriginalPosition.parentNode) {
          navOriginalPosition.parentNode.insertBefore(nav, navOriginalPosition.nextSibling);
        }
      };

      const handleResize = () => {
        if (mq.matches) {
          moveNavBack();
        } else {
          moveNavToPanel();
        }
      };

      handleResize();

      mq.addEventListener('change', handleResize);
    }
  }


  {
    const burger = document.getElementById('burger');
    const header = document.querySelector('.header');
    const panelMob = header && header.querySelector('.panel-mob');

    if (!burger || !panelMob) return;

    const mq = window.matchMedia('(max-width: 767.98px)');

    const burgerOpenClass = 'is-open';
    const panelOpenClass = 'is-open';

    const toggleMenu = () => {
      if (!mq.matches) return;
      burger.classList.toggle(burgerOpenClass);
      panelMob.classList.toggle(panelOpenClass);
      document.body.classList.toggle('no-scroll', panelMob.classList.contains(panelOpenClass));
    };

    const closeMenu = () => {
      burger.classList.remove(burgerOpenClass);
      panelMob.classList.remove(panelOpenClass);
      document.body.classList.remove('no-scroll');
    };

    burger.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMenu();
    });

    panelMob.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link && mq.matches) {
        closeMenu();
      }
    });

    mq.addEventListener('change', () => {
      if (!mq.matches) {
        closeMenu();
      }
    });
  }

  {
    const modalTriggers = document.querySelectorAll('.js-modal-trigger');

    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = trigger.getAttribute('data-modal-target');
        const modal = document.getElementById(targetId);
        if (modal) openModal(modal);
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('.modal__close')) {
        const modal = e.target.closest('.modal');
        closeModal(modal);
      }

      if (e.target.classList.contains('modal__overlay')) {
        const modal = e.target.closest('.modal');
        closeModal(modal);
      }
    });

    function openModal(modal) {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal(modal) {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }
  }

});





